<template>
  <div class="bg-slate-100 min-h-screen h-full relative">
    <NavigationBarComp :title="$attrs?.title" :stuck="true" />
    <router-view class="pt-12 min-h-fit"></router-view>
  </div>
</template>

<script>
  import NavigationBarComp from "@/components/NavigationBarComp.vue";

  export default {
    name: "DashboardLayout",
    components: {
      NavigationBarComp
    }
  };
</script>
